import type { Interview } from '../modules/TechnicalInterview';

const STORAGE_KEY = '@ehub/interview-history';
const MAX_HISTORY_ITEMS = 10;

export const getInterviewHistory = (): Interview[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    return JSON.parse(stored);
  } catch (error) {
    console.error('Error reading interview history:', error);
    return [];
  }
};

export const addInterviewToHistory = (interview: Interview): void => {
  try {
    const history = getInterviewHistory();
    history.unshift(interview);

    if (history.length > MAX_HISTORY_ITEMS) {
      history.length = MAX_HISTORY_ITEMS;
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
  } catch (error) {
    console.error('Error saving interview to history:', error);
  }
};

export const removeInterviewFromHistory = (date: string): void => {
  try {
    const history = getInterviewHistory();
    const filtered = history.filter(item => item.date !== date);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
  } catch (error) {
    console.error('Error removing interview from history:', error);
  }
};